// Libraries
import { ChangeEventHandler } from 'react';

// Styles
import styles from './ToggleCircle.module.css';

/**
 * @function ToggleCircle
 * Describe the component's function
 *
 * @example
 * return (
 *   <ToggleCircle
 *     text=''
 *     backgroundColor=''
 *     backgroundImage=''
 *     name=''
 *     value=''
 *     checked={false}
 *     disabled={false}
 *     onChange={() => false}
 *   />
 * )
 */
function ToggleCircle({
    text,
    backgroundColor,
    backgroundImage,
    name,
    value,
    checked,
    disabled,
    onChange,
}: ToggleCircleProps): JSX.Element {
    return (
        <label className={styles.container}>
            <input
                type="radio"
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                defaultChecked={checked}
            />
            {backgroundImage ? (
                <div
                    style={{ backgroundImage: `url(${backgroundImage})` }}
                ></div>
            ) : (
                <div
                    className={styles.circle}
                    style={{
                        backgroundColor: `var(--color-${backgroundColor})`,
                    }}
                ></div>
            )}
            <span>{checked === true ? <b>{text}</b> : text}</span>
        </label>
    );
}

/**
 * @interface ToggleCircleProps
 * Describes the properties required for the ToggleCircle component
 *
 * @property {string} text
 * @property {string} backgroundColor
 * @property {string} backgroundImage
 * @property {string} name
 * @property {string} value
 * @property {boolean} checked
 * @property {boolean} disabled
 * @property {ChangeEventHandler} onChange
 */
export interface ToggleCircleProps {
    text: string;
    backgroundColor?: string;
    backgroundImage?: string;
    name: string;
    value: string;
    checked: boolean;
    disabled: boolean;
    onChange: ChangeEventHandler<HTMLInputElement>;
}

// Exports
export default ToggleCircle;
